import { Component, Input } from "@angular/core";
import { NgxSpinnerService, NgxSpinnerModule } from "ngx-spinner";

@Component({
  selector: "app-block-spinner",
  template: `<ngx-spinner [name]="spinnerName"></ngx-spinner>`,
  standalone: true,
  imports: [NgxSpinnerModule],
})
export class SpinnerComponent2 {
  isSpinner: boolean;
  spinnerName = "";

  @Input() set name(val) {
    this.spinnerName = val;
  }

  @Input() set isSpinnerShow(val) {
    this.isSpinner = val;
    if (this.isSpinner) {
      this.spinnerShow();
    } else if (!this.isSpinner) {
      this.spinnerHide();
    }
  }

  constructor(private spinner: NgxSpinnerService) {}

  spinnerShow() {
    this.spinner.show(this.spinnerName, {
      size: "medium",
      fullScreen: false,
      bdColor: "rgba(255, 255, 255, 0.6)",
      color: "#098ee6",
      zIndex: 49,
    });
  }

  spinnerHide() {
    this.spinner.hide(this.spinnerName);
  }
}
